// Persisted UI settings, localStorage-backed. One key per setting.

const COOLER_SEARCH_KEY = "coolerSearch";

export const isCoolerSearchEnabled = () =>
    localStorage.getItem(COOLER_SEARCH_KEY) === "true";

export const setCoolerSearchEnabled = (enabled) => {
    localStorage.setItem(COOLER_SEARCH_KEY, String(Boolean(enabled)));
};
